<template>
	<footer>
		<div class="container">
			<!-- Social links -->
			<div class="social">
				<!-- Facebook -->
				<a href="https://www.facebook.com/jsunarja" class="fab fa-facebook-f" target="_blank" data-toggle="tooltip" data-placement="bottom"></a>
				<!-- Twitter -->
				<a href="https://twitter.com/jonathanvs_13" class="fab fa-twitter" target="_blank" data-toggle="tooltip" data-placement="bottom"></a>
				<!-- LinkedIn -->
				<a href="https://www.linkedin.com/in/jonathan-valentinus-sunarja-477445133/" class="fab fa-linkedin" target="_blank" data-toggle="tooltip" data-placement="bottom"></a>
			</div>

			<p><strong>&copy; {{START_YEAR}}&ndash;{{CURR_YEAR}}</strong>. Created and designed by Jonathan Valentinus Sunarja.</p>
			<a href="#" data-toggle="modal" data-target="#disclaimer" @click="showDisclaimerModal(true)">Disclaimer</a>
		</div>
	</footer>
</template>

<script>
import { mapActions } from 'vuex'

export default {
	data() {
		return {
			START_YEAR: 2018,
			CURR_YEAR: new Date().getFullYear()
		}
	},
    methods: {
		...mapActions(['showDisclaimerModal'])
	}
}
</script>

<style lang="scss" scoped>
footer {
	text-align: center;
	padding: 2rem 0;

	.container {
		p, a {
			font-size: 0.8rem;
		}

		p {
			color: $colour-grey-primary;
		}
	}
}

.social {
	margin-bottom: 1rem;
}

/* Formatting of social link symbols */
.fab {
	padding: 0.6rem;
	width: 40px;
	margin: 0 0.5rem;
	font-size: 1.25rem!important;
	text-align: center;
	text-decoration: none!important;
	border-radius: 50%;
	transition: 0.6s background-color;

	/* Formatting of Facebook symbol when being moused over */
	&.fa-facebook-f:hover {
		background: #3B5998;
		color: $colour-white;
	}

	/* Formatting of Twitter symbol when being moused over */
	&.fa-twitter:hover {
		background: #55ACEE;
		color: $colour-white;
	}

	/* Formatting of LinkedIn symbol when being moused over */
	&.fa-linkedin:hover {
		background: #007bb5;
		color: $colour-white;
	}
}
</style>
